// extracted by mini-css-extract-plugin
module.exports = {"secondary":"secondary_button-module--secondary--276ds"};